import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="14" height="8" viewBox="0 0 14 8" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="#D8D8D8" fillRule="evenodd"><path d="M2.11.86l5.03 5.03A.89.89 0 115.9 7.14L.86 2.11A.89.89 0 012.1.86z" /><path d="M12.48.86c.34.34.34.9 0 1.25L7.45 7.14A.89.89 0 116.19 5.9L11.22.86a.89.89 0 011.26 0z" /></g></svg>);